import {
	CHANGED_OPEN_PRIVATE_CHAT, FRIEND_LIST_UPDATED,
	HAS_NEW_PRIVATE_MESSAGE,
	LOADED_PRIVATE_CHAT_PAGE, PRIVATE_CHAT_LISTS_UPDATED, SET_HOVERED_PRIVATE_CHAT, UNREAD_PRIVATE_MESSAGES_CHANGED,
	UPDATE_DISPLAYED_PRIVATE_CHAT_ORDER
} from "../actions/privateChat";
import { PRIVATE_CHAT_PARTNER_PRESENCE_CHANGED } from 'react/redux/actions/privateChatPresence';
import { DIRECT_MESSAGE_READ } from 'react/redux/actions/directMessageRead';

// The layout preloads the unread DM conversation count into myUser. After that
// the server pushes the count with each direct message and each read; the DM
// list only holds a page of conversations, so it never counts them itself.
function preloadedUnreadConversationCount() {
	const preloadedUser = typeof myUser !== 'undefined' ? myUser : null;
	return (preloadedUser && Number(preloadedUser.unread_direct_conversation_count)) || 0;
}

const initialState = {
	displayedPrivateMessages: {},
	privateChatChanges: 0,
	lastLoadedPrivateChatPage: 0,
	loadedAllOpenPrivateChats: false,
	// Open conversations on the server, so the DM list can size itself before every page loads.
	openPrivateChatTotal: null,

	unreadPrivateMessageCount: preloadedUnreadConversationCount(),
	currentPrivateChat: null,
	openPrivateChats: {},
	closedPrivateChats: {},
	hoveredPrivateChatId: null,

	displayedFriendList: {},
};

export default (state = initialState, action) => {
	switch(action.type) {
		case FRIEND_LIST_UPDATED: {
			return {
				...state,
				displayedFriendList: action.payload
			};
		}
		case SET_HOVERED_PRIVATE_CHAT: {

			const { id, hovered } = action.payload;
			let setToId = null;
			if(hovered) {
				setToId = id;
			}
			else {
				if(id === state.hoveredPrivateChatId) {
					setToId = null;
				}
			}
			return {
				...state,
				hoveredPrivateChatId: setToId,
			};
		}
		case UNREAD_PRIVATE_MESSAGES_CHANGED: {
			const count = action.payload;
			return {
				...state,
				unreadPrivateMessageCount: count,
			};
		}
		case DIRECT_MESSAGE_READ:
			return {
				...state,
				unreadPrivateMessageCount: action.payload.unreadConversationCount,
			};
		case CHANGED_OPEN_PRIVATE_CHAT:
			return {
				...state,
				currentPrivateChat: action.payload
			};
		case PRIVATE_CHAT_LISTS_UPDATED:
			return {
				...state,
				openPrivateChats: action.payload.openPrivateChats,
				closedPrivateChats: action.payload.closedPrivateChats,
			};
		case LOADED_PRIVATE_CHAT_PAGE: {
			return {
				...state,
				lastLoadedPrivateChatPage: action.payload.page,
				loadedAllOpenPrivateChats: !action.payload.hasMore,
				openPrivateChatTotal: action.payload.total ?? state.openPrivateChatTotal,
			};
		}
		case PRIVATE_CHAT_PARTNER_PRESENCE_CHANGED:
		case HAS_NEW_PRIVATE_MESSAGE: {
			return {
				...state,
				privateChatChanges: state.privateChatChanges + 1
			};
		}
		case UPDATE_DISPLAYED_PRIVATE_CHAT_ORDER: {
			return {
				...state,
				displayedPrivateMessages: action.payload,
			};
		}
		default:
			return state;
	}
}